<template>
  <div class="service-cards-container">
    <!-- 大卡片区域 (2个并排) -->
    <div class="large-cards">
      <div 
        v-for="card in largeCards" 
        :key="card.id"
        class="card large-card"
        @click="handleCardClick(card)"
      >
        <img :src="card.imageUrl" :alt="'服务卡片' + card.id" class="card-image" />
      </div>
    </div>

    <!-- 小卡片区域 (3个并排) -->
    <div class="small-cards">
      <div 
        v-for="card in smallCards" 
        :key="card.id"
        class="card small-card"
        @click="handleCardClick(card)"
      >
        <img :src="card.imageUrl" :alt="'服务卡片' + card.id" class="card-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceCards',
  setup() {
    const largeCards = [
      {
        id: 1,
        imageUrl: 'https://img1.rrzuji.cn/uploads/activity/1812/19/s/d6e16e12d31ca5eaaf18ef8c8c6a3d82.png',
        link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAPsJK1olXDYDZBoCUBVIMzZNXhpXVhgcDwYCXhxDXHBTTkRHA1ocDBsJVEVTbT9aXjVUUUJdDAACFBtFRjdPQx5dSkJdDAACZgpHVTtmQw4ZXgEAVVldOC1WeCR0WB1FPnx4PxYESQxNZBBMASsZUTYHVF9dD0wQAmcLK1gUXwIBVFpYAUwnM28JKxB7XDYAVF9dAUseBmoMK1sTWwcBXFpbCUsSAmg4HFscbdK27Ib0jZ6ajrmXh1sdVQMyZG5eOEwXCnsOaRpHSQBwZG5eCHsUM18KGloRVDYyitPtdkJiQxp4awwUDUZ5Dh8LCpWas35jYlsdVQATZG5tOA'
      },
      {
        id: 2,
        imageUrl: 'https://img1.rrzuji.cn/uploads/activity/1812/19/s/e34c9380a82898a4a118280aef879eca.png',
        link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAPoJK1olXDYDZBoCUBVIMzZNXhpXVhgcDwYCXhxDXHBTTkRHA1ocDBsJVEVTbT9aXjVUUUJdDAACFBtFRjdPQx5dSkJdDAACZgpHVTtmQw4ZXwcEVlhteAsUQypBR1J3FE5lLzYjCTtHBh1Ue1cZbQMCVV5aD0wWC2w4GFoXWQUCUFtUD3snA244UDUUbQQCVV5UCEISBms4G10TXAUKUFheD0MTB18PG1IlibK6jPfY3caa1fCUG1MdWDYyZF1tD0seF2l6WgkBW3QyZF1dOEgnM20JGl8cbTbc2e4oCz4VexhLHl11DWQHUSYg1sanEh14G18UWxcyZG5t'
      }
    ];

    const smallCards = [
      {
        id: 3,
        imageUrl: 'https://img30.360buyimg.com/ads/jfs/t1/389688/36/9840/124490/697970ffF587cdbe3/027615e15e859e8a.png',
        link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAPsJK1olXDYDZBoCUBVIMzZNXhpXVhgcFR0DFxcIWDoXSQVJQ1pSCQNDWBlSWyhcBVlvOwJWKVk_Ty5tUT1jZj5lAQ9hEFkdXQ1rfjAWQwRACU8dDRsBVXteSgxASEUdJmNnMkAWATkTahVMZwxlUQoyUV5cCEwQBG4AGGsWXAQGV15ZDUIQM18IGmteMwcyVl5cCEIXCmoNH2sVWwADV1ZZCkIWBmYAK1wVVDbW4OaFoc7CjuLehMcVVQ4HZG5tC3sQA2YcHSlUDxIEJm5tCnsUM18KGloRVDYyitDJbk92AGcLWSlVPlphDgcAUpWZl35jYlMVXQUTZG5tOA'
      },
      {
        id: 4,
        imageUrl: 'http://img30.360buyimg.com/ads/jfs/t1/395363/33/359/188607/6981ca0fFe78f9f24/027615e15e28b701.png',
        link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAPsJK1olXDYDZBoCUBVIMzZNXhpXVhgcFR0DFxcIWDoXSQVJQ1pSCQNDWBlSWyhcBVhNDnAGBAUWd0l-ZgpsTDoTWU5HLVk6czRfZ2oWQwRACU8dDRsBVXtjYmZJQCRsNWMHDANaeDAXeRpWATtlUQoyUV5cCEwQBG4AGGsWXAQGV15ZDUIQM18IGmteMwcyVl5cCEIXCmoNH2sVWwADV1ZbC0oUAWkBK1wVVDbW4OaFoc7CjuLehMcVVQ4HZG5tC3sQA2YcHSlUDxIEJm5tCnsUM18KGloRVDYyitDJdk1fZxwBezwSPA5_DF41Q5WZl356a1kRWwETZG5tOA'
      },
      {
        id: 5,
        imageUrl: 'https://img30.360buyimg.com/ads/jfs/t1/213469/13/9523/106225/61cd9a02E69e56d79/d55c3540e15f4742.png',
        link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAPkJK1olXDYDZBoCUBVIMzZNXhpXVhgcDwYCXhxDXHBTTkRHA1ocDBsJVEVTbT9aXjVUUUJdDAACFBtFRjdPQx5dSkJdDAACZgpHVTtmQw4ZXwcEVlhtcgwXBwsIejpwH3hmMw4hTTtqQARQe1cZbQMCVV5aD0wWC2w4GFoXWQUCUFtUD3snA244UDUUbQQCVV5UCEISBms4G10TXAUKUF5VCkweCl8PG1IlibK6jPfY3caa1fCUG1MdWDYyZF1tD0seF2l6WgkBW3QyZF1dOEgnM20JGl8cbTbc2sohAQJLSm5tcAcQOU1yFl4L1sWDEh1jG18QTDYyZG4'
      }
    ];

    const handleCardClick = (card) => {
      if (card.link) {
        window.open(card.link, '_blank');
      }
    };

    return {
      largeCards,
      smallCards,
      handleCardClick
    };
  }
};
</script>

<style scoped>
.service-cards-container {
  padding: 16px 12px;
  background: #f7f8fa;
}

/* 大卡片区域 */
.large-cards {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.large-card {
  flex: 1;
  position: relative;
  overflow: hidden;
}

/* 小卡片区域 */
.small-cards {
  display: flex;
  gap: 8px;
}

.small-card {
  flex: 1;
  position: relative;
  overflow: hidden;
}

/* 通用卡片样式 */
.card {
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
}

.card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

/* 卡片图片 */
.card-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 12px;
}

/* 大卡片固定高度 */
.large-card {
  height: 140px;
}

.large-card .card-image {
  min-height: 140px;
}

/* 小卡片固定高度 */
.small-card {
  height: 120px;
}

.small-card .card-image {
  min-height: 120px;
}

/* 响应式优化 */
@media (max-width: 360px) {
  .large-card {
    height: 120px;
  }
  
  .large-card .card-image {
    min-height: 120px;
  }
  
  .small-card {
    height: 100px;
  }
  
  .small-card .card-image {
    min-height: 100px;
  }
}

/* 悬停效果 */
.card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
</style>
